import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { initAuth } from '../../AdminDashboard/redux/thunks/adminThunks';
import {
  selectIsAuthenticated,
  selectAuthStatus,
} from '../../AdminDashboard/redux/selectors/adminSelectors';
import { ADMIN_ROUTES } from '../../routes/patientRoutes/routePaths';
import { axiosAdmin } from '../../api/axios';
  import {ADMIN_AUTH_PATHS } from '../../api/endpoints'
  

export default function ProtectedAdminRoute() {
  const [status, setStatus] = useState('checking'); // checking | ok | ko

  useEffect(() => {
    axiosAdmin
      .get(ADMIN_AUTH_PATHS.ME)
      .then(() => setStatus('ok'))
      .catch(() => setStatus('ko'));
  }, []);

  if (status === 'checking') {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}>
        <Spin size="large" />
      </div>
    );
  }

  return status === 'ok'
    ? <Outlet />
    : <Navigate to={ADMIN_ROUTES.LOGIN} replace />;
}